module.exports = __webpack_public_path__ + "static/hyperv_16.978b99ec.jpg";